import { useEffect } from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { ThemeProvider } from "@/components/theme";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Seo from "@/components/Seo";
import { Toaster } from "@/components/ui/sonner";

import Home from "@/pages/Home";
import Solutions from "@/pages/Solutions";
import Approach from "@/pages/Approach";
import Insights from "@/pages/Insights";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import NotFound from "@/pages/NotFound";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function Page({ children }) {
    return (
        <motion.main
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
        >
            {children}
        </motion.main>
    );
}

function AnimatedRoutes() {
    const location = useLocation();
    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                <Route path="/" element={<Page><Home /></Page>} />
                <Route path="/solutions" element={<Page><Solutions /></Page>} />
                <Route path="/approach" element={<Page><Approach /></Page>} />
                <Route path="/insights" element={<Page><Insights /></Page>} />
                <Route path="/about" element={<Page><About /></Page>} />
                <Route path="/contact" element={<Page><Contact /></Page>} />
                <Route path="/privacy" element={<Page><Privacy /></Page>} />
                <Route path="*" element={<Page><NotFound /></Page>} />
            </Routes>
        </AnimatePresence>
    );
}

function App() {
    return (
        <ThemeProvider>
            <BrowserRouter>
                <SmoothScroll>
                    <Seo />
                    <ScrollToTop />
                    <Navbar />
                    <AnimatedRoutes />
                    <Footer />
                    <Toaster position="bottom-right" />
                </SmoothScroll>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
